import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { DialogOpenReport } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
//PAGE
import P208List from "./P208List";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { P208GetDataList } from "../../../service/200/P208Service";
import DialogGenReport from "../../../components/DialogReport/DialogGenReport";
import { onP218GetDataList } from "../../../Report/218/RPT218CallService";
import { excelRPT218, pdfRPT218 } from "../../../Report/218/RPT218";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { SplitButton } from "primereact/splitbutton";

export default function P208() {
    const menu = useRef(null);
    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);

    const [dataTable, setDataTable] = useState([]);
    const [dataRPT, setDataRPT] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pathname, setPathname] = useState(false);
    const [contractNo, setContractNo] = useState(false);
    const [routeNo, setRouteNo] = useState("");
    const [contractorName, setContractorName] = useState("");
    const [supervisorName, setSupervisorName] = useState("");

    const toggleMenu = (event, data) => {
        if (data && data.contractNo) {
            setContractNo(data.contractNo ? data.contractNo : "");
            setRouteNo(data.routeNo);
            setPathname(data.functionId ? data.functionId : "");
            setContractorName(data.contractorName ? data.contractorName : "");
            setSupervisorName(data.supervisorName ? data.supervisorName : "");
            menu.current.toggle(event);
        } else {
            showMessages("warn", `เกิดข้อผิดพลาด :`, `ไม่พบเลขที่สัญญา `);
        }
    };

    const [dialogPDF, setDialogPDF] = useState(false);
    const [dialogReport, setDialogReport] = useState({ dialog: false, show: false });

    // SEARCH
    const [searchData, setSearchData] = useState({ userId: dataUserSession() ? dataUserSession().userId : "" });

    useEffect(() => {
        if (dataUserSession()) {
            // if (history.location.state && history.location.state) {
            //     setSearchData({
            //         ...searchData,
            //     });
            // }
        } else {
            history.push("/login");
        }
    }, []);

    // useEffect(() => {
    //     console.log('dataTable ',dataTable);
    // }, [dataTable]);

    useEffect(() => {
        // console.log('searchData ',searchData);
        onP208GetDataList();
    }, [searchData]);

    const onP208GetDataList = () => {
        setLoading(true);
        P208GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages(toast, "error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const actionMenu = (data, rowData, page) => {
        let obj = {
            contractNo: rowData.contractNo ? rowData.contractNo : "",
            routeNo: rowData.routeNo,
            routeName: rowData.routeName,
            contractorName: rowData.contractorName ? rowData.contractorName : "",
            supervisorName: rowData.supervisorName ? rowData.supervisorName : "",
            pathname: rowData.functionId ? rowData.functionId : "",
        };

        if (obj.contractNo) {
            setContractNo(obj.contractNo);
            setRouteNo(obj.routeNo);
            setPathname(obj.pathname);
            setContractorName(obj.contractorName);
            setSupervisorName(obj.supervisorName);
            // menu.current.toggle(event);
        } else {
            showMessages("warn", `เกิดข้อผิดพลาด :`, `ไม่พบเลขที่สัญญา `);
        }

        let fun = "208";
        if (data && data.item) {
            if (data.item.function && data.item.function === "CHK") {
                fun = obj.pathname;
            } else if (data.item.pathname) {
                fun = data.item.pathname;
            }

            if (fun === "218") {
                // onOpenExport();dataRPT, setDataRPT
                let req = {
                    contractNo: rowData.contractNo ? rowData.contractNo : "",
                    routeNo: rowData.routeNo,
                    userId: dataUserSession() ? dataUserSession().userId : "",
                };
                onP218GetDataList(setLoading, req, setDataRPT, toast);
                setDialogReport({ dialog: true, show: false });
            } else {
                if (page === "241") {
                    goPage_241(fun, obj);
                } else {
                    goPage(fun, obj);
                }
            }
        }
    };

    const goPage = (data, obj) => {
        history.push({
            pathname: data,
            state: {
                contractNo: obj.contractNo,
                routeNo: obj.routeNo,
                routeName: obj.routeName,
                contractorName: obj.contractorName,
                supervisorName: obj.supervisorName,
            },
        });
    };
    const goPage_241 = (data, obj) => {
        history.push({
            pathname: data,
            state: {
                dataSrh: {
                    contractNo: obj.contractNo,
                    routeNo: obj.routeNo,
                    contractorName: obj.contractorName,
                    supervisorName: obj.supervisorName,
                },
            },
        });
    };

    const actionMenuColumn = (rowData) => {
        const overlayMenuItems = [
            {
                id: 0,
                label: "สรุปค่างานเส้นทาง",
                icon: "pi pi-fw pi-external-link",
                pathname: "211",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 1,
                label: "ประมาณการ",
                icon: "pi pi-fw pi-external-link",
                pathname: "212",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 2,
                label: "กระดาษทด",
                icon: "pi pi-fw pi-external-link",
                function: "CHK",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 3,
                label: "บันทึกผลการปฏิบัติงานประจำวัน",
                icon: "pi pi-fw pi-external-link",
                pathname: "215",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 4,
                label: "ตรวจสอบการปฏิบัติงาน",
                icon: "pi pi-fw pi-external-link",
                pathname: "220",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 5,
                label: "รายงานการสรุปผลการก่อสร้าง",
                icon: "pi pi-fw pi-external-link",
                pathname: "210",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 6,
                label: "P1",
                icon: "pi pi-fw pi-external-link",
                pathname: "230",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 7,
                label: "P2",
                icon: "pi pi-fw pi-external-link",
                pathname: "233",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 8,
                label: "ประเมิน 3 มิติ",
                icon: "pi pi-fw pi-external-link",
                // pathname: "240",
                pathname: "241",
                command: (e) => {
                    actionMenu(e, rowData, "241");
                },
            },
            {
                id: 9,
                label: "ลงแนวเส้นท่อใน GIS",
                icon: "pi pi-fw pi-external-link",
                pathname: "419",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            {
                id: 10,
                label: "ใบแจ้งเตือน",
                icon: "pi pi-fw pi-external-link",
                pathname: "216",
                command: (e) => {
                    actionMenu(e, rowData);
                },
            },
            // {
            //     label: "รายงานการเบิกวัสดุ/อุปกรณ์",
            //     icon: "pi pi-fw pi-external-link",
            //     pathname: "218",
            //     command: (e) => {
            //         actionMenu(e, rowData);
            //     },
            // },
        ];
        // let labelShow = <span className="show-responsive">ตัวเลือก</span>;

        const _filterMenu = overlayMenuItems.filter((e) => {
            return e.id !== 1 && e.id !== 2 && e.id !== 7;
        });

        return (
            <>
                <div style={{ textAlign: "center" }}>
                    {/* btn-md-responsive */}
                    {/* <Button
                        type="button" icon="pi pi-list" className="p-button-secondary btn-label-responsive btn-option"
                        onClick={(e) => toggleMenu(e, rowData)}
                        tooltip="คลิกเพื่อเปิด ตัวเลือก"
                        tooltipOptions={{ position: "top" }}
                        label={labelShow}
                    /> */}
                    <SplitButton
                        // label={'เลือก'}
                        icon="pi pi-bars"
                        model={rowData.contractNoForDisplay !== "" ? overlayMenuItems : _filterMenu}
                        className="p-button-secondary p-mr-2"
                    />
                </div>
            </>
        );
    };

    const onExport = (act) => {
        // console.log(act);
        switch (act) {
            case "PDF":
                pdfRPT218(dataRPT, setLoading, setDialogPDF);
                break;
            case "EXCEL":
                excelRPT218(dataRPT, setLoading, toast);
                break;
            default:
                break;
        }
        setDialogReport({ dialog: false, show: false });
    };

    // const onOpenExport = () => {
    //     setDialogReport({ dialog: true, show: false });
    // };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                {/* <Menu ref={menu} model={overlayMenuItems} popup /> */}
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">รายละเอียดสัญญา/เส้นทาง</h2>
                        <hr /> */}
                        <P208List dataTable={dataTable} goPage={goPage} menu={menu} toggleMenu={toggleMenu} actionMenuColumn={actionMenuColumn} />
                    </div>
                </div>
            </div>

            <DialogOpenReport header="รายงานการเบิกวัสดุ/อุปกรณ์" dialog={dialogPDF} setDialog={setDialogPDF} />

            <DialogGenReport dialog={dialogReport} setDialog={setDialogReport} setExport={onExport} pdf={true} excel={true} />
        </>
    );
}
